import { useOnboarding } from '../_hooks/use-onboarding'
import {
  Dialog,
  DialogContainer,
  DialogHeader,
  DialogSubtitle,
  DialogTopTitle,
} from './Dialog.styles'
import { PhoneInput } from '@common/components/PhoneInput'
import { ButtonContainer } from '@common/components/ButtonContainer'
import { Button } from '@common/components/Button'
import { useState } from 'react'

export const CapturePhoneDialog = ({
  email,
  defaultValue,
  onNext,
  onBack,
}: {
  email: string
  defaultValue: string
  onNext: (phoneNumber: string, retryInSeconds: number) => void
  onBack: () => void
}) => {
  const [error, setError] = useState('')
  const { sendCode, loading } = useOnboarding()
  const [phoneNumber, setPhoneNumber] = useState(defaultValue)

  return (
    <DialogContainer
      onSubmit={(e) => {
        e.preventDefault()

        sendCode(email, phoneNumber).then(({ data }) => {
          if (data?.onboardCodeSend?.retryInSeconds) {
            onNext(phoneNumber, data.onboardCodeSend.retryInSeconds)
          }

          if (data?.onboardCodeSend?.error) {
            setError(data.onboardCodeSend.error)
          }
        })
      }}
    >
      <Dialog>
        <DialogTopTitle>Steg 3 av 3</DialogTopTitle>
        <DialogHeader>Vad är ditt telefonnummer?</DialogHeader>
        <DialogSubtitle>Du kommer att få en engångskod skickad till dig.</DialogSubtitle>
        <div style={{ marginTop: '1rem' }} />
        <PhoneInput
          error={error}
          value={phoneNumber}
          autoFocus
          onChange={(e) => setPhoneNumber(e.currentTarget.value)}
        />
        <div style={{ marginTop: '1rem' }} />
        <ButtonContainer>
          <Button loading={loading} type="submit" disabled={!phoneNumber}>
            Nästa
          </Button>
          <Button variant="secondary" onClick={() => onBack()}>
            Tillbaka
          </Button>
        </ButtonContainer>
      </Dialog>
    </DialogContainer>
  )
}
